// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "534c9a2f9a2a";
export const BUILD_VERSION_NUMBER = 21;
